module.exports = __webpack_public_path__ + "img/dixie.b9d5dc9a.jpg";